import React from "react";
import ItemSelector from "components/ItemSelector";
import ItemView from "components/ItemView";
import ProtectedRoute from "components/ProtectedRoute";
import { accessControl } from "utils/accessControl";

// Admin Imports
import MainDashboard from "views/admin/default";
import NFTMarketplace from "views/admin/marketplace";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import RTLDefault from "views/rtl/default";
import AddWarehouse from "views/admin/warehouse/AddWarehouse";
import AddFairtradeRCN from "views/admin/warehouse/AddFairtradeRCN";
import AddOrganicRCN from "views/admin/warehouse/AddOrganicRCN";
import ViewWarehouse from "views/admin/warehouse/ViewWarehouse";
import ViewOrganic from "views/admin/warehouse/ViewOrganic";
import ViewFairTrade from "views/admin/warehouse/ViewFairTrade";
import Settings from "views/admin/settings/Settings";
import WarehouseDashboard from "views/admin/warehouse/WarehouseDashboard";
import FinishedDashboard from "views/admin/finishedProductWarehouse/FinishedDashboard";
import ScanWarehouse from "views/admin/warehouse/ScanWarehouse";
import QRScanner from "views/admin/warehouse/QRScanner";
import UserList from "views/admin/users/UserList";
import AddUser from "views/admin/users/AddUser";
import EditUser from "views/admin/users/EditUser";
import ViewAnalyzed from "views/admin/warehouse/ViewAnalyzed";
import AnalyzeFairTradeRCN from "views/admin/warehouse/AnalyzeFairTradeRCN";
import AddAnalyzedOrganicRCN from "views/admin/warehouse/AddAnalyzedOrganicRCN";
import AddAnalyzedConRCN from "views/admin/warehouse/AddAnalyzedConRCN";
import AddRawRCN from "views/admin/warehouse/AddRawRCN";
import CalibrateAnalyzed from "views/admin/warehouse/CalibrateAnalyzed";
import AddCalibratedData from "views/admin/warehouse/AddCalibratedData";
import Returns from "views/admin/warehouse/Returns";
import Consume from "views/admin/warehouse/Consume";
import Stock from "views/admin/warehouse/Stock";
import ConsumeForm from "views/admin/warehouse/ConsumeForm";
import ZoneDetails from "views/admin/warehouse/ZoneDetails";
import NewDashWare from "views/admin/warehouse/NewDashWare";
import ConsumptionTable from "views/admin/warehouse/ConsumptionTable";
import BulkReceivingUpload from "views/admin/warehouse/BulkReceivingUpload";
import BulkCalibrate from "views/admin/warehouse/BulkCalibrate";
import ReceivingRecords from "views/admin/warehouse/ReceivingRecords";
import CalibrationRecords from "views/admin/warehouse/CalibrationRecords";
import CalibratedDetail from "views/admin/warehouse/CalibratedDetail";
import ReturnsRecords from "views/admin/warehouse/ReturnsRecords";
import ProductDetails from "views/admin/finishedProductWarehouse/ProductDetails";
import AddFinProduct from "views/admin/finishedProductWarehouse/AddFinProduct";
import ProductList from "views/admin/finishedProductWarehouse/ProductList";
import Age from "views/admin/finishedProductWarehouse/Age";
import FinishZone from "views/admin/finishedProductWarehouse/FinishZone";
import FinishZoneDetails from "views/admin/finishedProductWarehouse/FinishZoneDetails";
import Export from "views/admin/finishedProductWarehouse/Export";
import ProductTypeDetail from "views/admin/finishedProductWarehouse/ProductTypeDetail";
import ReworkRecords from "views/admin/finishedProductWarehouse/ReworkRecords";
import DeletedProductRecords from "views/admin/finishedProductWarehouse/DeletedProductRecords";
import ExportRecords from "views/admin/finishedProductWarehouse/ExportRecords";
import Report from "views/admin/finishedProductWarehouse/Report";
import DailyReport from "views/admin/finishedProductWarehouse/DailyReport";
import SalesForecastReport from "views/admin/finishedProductWarehouse/SalesForecastReport";
import AnalystDashboard from "views/admin/AnalystProcess/AnalystDashboard";
import ProductDistribution from "views/admin/AnalystProcess/ProductDistribution";
import AnalystEntry1 from "views/admin/AnalystProcess/AnalystEntry1";
import AnalystEntry2 from "views/admin/AnalystProcess/AnalystEntry2";
import AnalysesEntryCard from "views/admin/AnalystProcess/AnalysesEntryCard";
import FieldAnalysis from "views/admin/AnalystProcess/FieldAnalysis";
import FieldAnalysisRecords from "views/admin/AnalystProcess/FieldAnalysisRecords";
import WholesRecords from "views/admin/AnalystProcess/WholesRecords";
import PiecesRecords from "views/admin/AnalystProcess/PiecesRecords";
import { PriceInput } from "views/admin/CashewPrice/PriceInput";
import Request from "views/admin/CashewPrice/Request";
import AgentRequest from "views/admin/CashewPrice/AgentRequest";
import VisitRequest from "views/admin/CashewPrice/VisitRequest";
import FarmerList from "views/admin/CashewPrice/FarmerList";
import AddManPeelingData from "views/admin/manualpeeling/AddManPeelingData";
import Performance from "views/admin/manualpeeling/Performance";
import WorkerProfile from "views/admin/manualpeeling/WorkerProfile";
import AddWorker from "views/admin/manualpeeling/AddWorker";
import Comparison from "views/admin/manualpeeling/Comparison";
import WorkerList from "views/admin/manualpeeling/WorkerList";
import DataRecords from "views/admin/manualpeeling/DataRecords";
import SMSNotification from "views/admin/manualpeeling/SMSNotification";
import ShiftSMS from "views/admin/shift/ShiftSMS";
import NurseLeave from "views/admin/shift/NurseLeave";
import HRManager from "views/admin/shift/HRManager";
import PassCreate from "views/admin/shift/PassCreate";
import ShiftRecords from "views/admin/shift/ShiftRecords";
import ShiftLogs from "views/admin/shift/ShiftLogs";
import WorkerHoursReport from "views/admin/shift/WorkerHoursReport";
import AbsentCheck from "views/admin/manualpeeling/AbsentCheck";
import RiskReport from "views/admin/manualpeeling/RiskReport";
import RcnDeliveryDashboard from "views/admin/rcnDelivery/Dashboard";
import DeliveryForm from "views/admin/rcnDelivery/DeliveryForm";
import DispatchRecords from "views/admin/rcnDelivery/DispatchRecords";
import IncidenceReport from "views/admin/rcnDelivery/IncidenceReport";
// import LMSLearning from "views/admin/lms/LMSLearning";
// import DomainPerformanceDashboard from "views/admin/lms/DomainPerformanceDashboard";

// Auth Imports
import SignIn from "views/auth/SignIn";
import { Departments } from "views/auth/Departments";


// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock,
  MdInventory,
  MdAdd,
  MdVisibility,
  MdQrCode2,
  MdSettings,
  MdQrCodeScanner,
  MdWarehouse,
  MdPeople,
  MdAnalytics,
  MdAddCircle,
  MdUpload,
  MdFactory,
  MdList,
  MdTimer,
  MdBuild,
  MdAssessment,
  MdLocalShipping,
  MdDelete,
  MdReceipt,
  MdAssignment,
  MdCompare,
  MdGroup,
  MdNotificationsActive,
  MdScience,
  MdCategory,
  MdAgriculture,
  MdStorage,
  MdEditNote,
  MdCheckCircle,
  MdDescription,
  MdWorkOff,
  MdWarning,
  MdSchool,
  MdMenuBook,
  MdLocalHospital,
  MdDirectionsRun,
  MdSearch,
} from "react-icons/md";
// import Departments from "views/auth/Departments";

// Access control functions using centralized system
const shouldHideMenu = (menuName) => () => !accessControl.canAccessMenu(menuName);

// Check if user has Field Analyst unit
const isFieldAnalysisUnit = () => {
  const userInfo = accessControl.getUserInfo();
  const unit = (userInfo?.unit || '').toLowerCase();
  return unit === 'field analyst' || unit === 'field analysis';
};

// Check if user is standard Analyst (not Field Analyst)
const isAnalystUser = () => {
  const userInfo = accessControl.getUserInfo();
  const unit = (userInfo?.unit || '').toLowerCase();
  return unit === 'analyst';
};

// Check if user has Factory Analyst unit
const isFactoryAnalystUnit = () => {
  const userInfo = accessControl.getUserInfo();
  const unit = (userInfo?.unit || '').toLowerCase();
  return unit === 'factory analyst';
};

const routes = [
  // {
  //   name: "Main Dashboard",
  //   layout: "/admin",
  //   path: "default",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <MainDashboard />,
  // },
  {
    name: "RCN Warehouse",
    layout: "/admin",
    path: "warehouse",
    
    icon: <MdWarehouse className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <WarehouseDashboard />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('rcnWarehouse'),

    submenu: [
      {
        name: "Dashboard",
        layout: "/admin",
        path: "warehouse/dashboard",
        icon: <MdHome className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <WarehouseDashboard />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: false,
      },
      {
        name: "Sign In",
        layout: "/auth",
        path: "sign-in",
        icon: <MdLock className="h-6 w-6" />,
        hidden: true,
        component: <SignIn />,
      },
      // {
      //   name: "Add Receiving Data",
      //   layout: "/admin",
      //   path: "warehouse-add",
      //   icon: <MdAdd className="h-5 w-5" />,
      //   component: <ItemSelector />,
      //   selectable: true,
      // },
      {
        name: "Add Calibrated Data",
        layout: "/admin",
        path: "warehouse/add-calibrated",
        icon: <MdAddCircle className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddCalibratedData />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Calibration Records",
        layout: "/admin",
        path: "warehouse/calibration-records",
        icon: <MdInventory className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <CalibrationRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Return Records",
        layout: "/admin",
        path: "warehouse/return-records",
        icon: <MdReceipt className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ReturnsRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Returns",
        layout: "/admin",
        path: "warehouse/returns",
        icon: <MdReceipt className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Returns />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Calibration Detail",
        layout: "/admin",
        path: "warehouse/calibrated/:id",
        component: <CalibratedDetail />,
        hidden: true,
        selectable: false,
      },
      {
        name: "Add Warehouse",
        layout: "/admin",
        path: "warehouse-add/new",
        component: <AddWarehouse />,
        hidden: true,
        selectable: false,
      },
      {
        name: "Add Fair Trade RCN",
        layout: "/admin",
        path: "warehouse-add/fairtrade",
        component: <AddFairtradeRCN />,
        hidden: true,
        selectable: false,
      },
      {
        name: "Add Organic RCN",
        layout: "/admin",
        path: "warehouse-add/organic",
        component: <AddOrganicRCN />,
        hidden: true,
        selectable: false,
      },


      {
        name: "View",
        layout: "/admin",
        path: "warehouse-view",
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ItemView />,
        selectable: true,
        hidden: true,
      },
      {
        name: "View Calibrated RCN",
        layout: "/admin",
        path: "warehouse/view",
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ViewWarehouse />,
        selectable: true,
        hidden: true,

      },
      {   
        name: "View Organic RCN",
        layout: "/admin",
        path: "warehouse/view/organic",   
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ViewOrganic />,
        selectable: true,
        hidden: true,
      },
      {
        name: "View Fair Trade RCN",
        layout: "/admin",
        path: "warehouse/view/fairtrade",
        icon: <MdVisibility className="h-5 w-5" />,
        component: <ViewFairTrade />, 
        selectable: true,
        hidden: true,

      },
      
      {
        name: "Scan QR",
        layout: "/admin",
        path: "warehouse-scan",
        icon: <MdQrCodeScanner className="h-5 w-5" />,
        component: <QRScanner />,
        hidden: true,
        selectable: true,
      },
      {
        name: "Scan Result",
        layout: "/admin",
        path: "warehouse-view/:id",
        component: <ScanWarehouse />,
        hidden: true,
        selectable: false
      },
      {
        name: "View Analyzed",
        layout: "/admin",
        path: "warehouse/view-analyzed",
        icon: <MdAnalytics className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ViewAnalyzed />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      {
        name: "Analyze Fair Trade RCN",
        layout: "/admin",
        path: "warehouse/analyze-fairtrade",
        icon: <MdAnalytics className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AnalyzeFairTradeRCN />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      {
        name: "Analyze Organic RCN",
        layout: "/admin",
        path: "warehouse/analyze-organic",
        icon: <MdAnalytics className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddAnalyzedOrganicRCN />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      {
        name: "Analyze Conventional RCN",
        layout: "/admin",
        path: "warehouse/analyze-conventional",
        icon: <MdAnalytics className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddAnalyzedConRCN />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      {
        name: "Calibrate Analyzed RCN",
        layout: "/admin",
        path: "warehouse/calibrate-analyzed",
        icon: <MdAnalytics className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <CalibrateAnalyzed />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      {
        name: "Stacked Zone",
        layout: "/admin",
        path: "warehouse/consume",
        icon: <MdInventory className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Consume />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Consume Form",
        layout: "/admin",
        path: "warehouse/consume/form",
        component: (
          <ProtectedRoute>
            <ConsumeForm />
          </ProtectedRoute>
        ),
        hidden: true,
        selectable: false,
      },
      {
        name: "Stock Overview",
        layout: "/admin",
        path: "warehouse/stock",
        icon: <MdInventory className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Stock />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,

      },
      {
        name: "Zone Details",
        layout: "/admin",
        path: "warehouse/zone-details/:zoneId",
        component: <ZoneDetails />,
        hidden: true,
      },
      {
        name: "Consumption Records",
        layout: "/admin",
        path: "warehouse/consumption",
        icon: <MdInventory className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ConsumptionTable />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Bulk Receiving Upload",
        layout: "/admin",
        path: "bulk-receiving-upload",
        icon: <MdUpload className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <BulkReceivingUpload />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      {
        name: "Bulk Calibration Upload",
        layout: "/admin",
        path: "bulk-calibration-upload",
        icon: <MdUpload className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <BulkCalibrate />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
      // {
      //   name: "Generate QR",
      //   layout: "/admin",
      //   path: "warehouse-qr",
      //   icon: <MdQrCode2 className="h-5 w-5" />,
      //   component: <MainDashboard />,
      // }
    ]
  },
  {
    name: "Users",
    layout: "/admin",
    path: "users",
    icon: <MdPeople className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <UserList />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('users'),

    submenu: [
      {
        name: "View Users",
        layout: "/admin",
        path: "users",
        icon: <MdVisibility className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <UserList />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Add User",
        layout: "/admin",
        path: "users/add",
        icon: <MdAdd className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddUser />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Edit User",
        layout: "/admin",
        path: "users/edit/:id",
        component: (
          <ProtectedRoute>
            <EditUser />
          </ProtectedRoute>
        ),
        hidden: true,
        selectable: false,
      }
    ]
  },
  
  


  // {
  //   name: "NFT Marketplace",
  //   layout: "/admin",
  //   path: "nft-marketplace",
  //   icon: <MdOutlineShoppingCart className="h-6 w-6" />,
  //   component: <NFTMarketplace />,
  // },
  // {
  //   name: "Data Tables",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  // },
  // {
  //   name: "Profile",
  //   layout: "/admin",
  //   path: "profile",
  //   icon: <MdPerson className="h-6 w-6" />,
  //   component: <Profile />,
  // },
  {
    name: "Settings",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <Settings />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('settings'),
  },
  
  {
    name: "Departments",
    layout: "/auth",
    path: "departments",
    icon: <MdLock className="h-6 w-6" />,
    component: <Departments />,
    hidden: true,
  },
  // {
  //   name: "RTL Admin",
  //   layout: "/rtl",
  //   path: "rtl",
  //   icon: <MdHome className="h-6 w-6" />,
  //   component: <RTLDefault />,
  // },
  {
    path: "/warehouse/view",
    element: <ViewWarehouse />,
  },
  // {
  //   name: "New Warehouse Dashboard",
  //   layout: "/admin",
  //   path: "new-warehouse-dashboard",
  //   icon: <MdWarehouse className="h-6 w-6" />,
  //   component: <NewDashWare />,
  // },
  {
    name: "Finished Products",
    layout: "/admin",
    path: "finished-products",
    icon: <MdFactory className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <FinishedDashboard />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('finishedProducts'),

    submenu: [
      {
        name: "Dashboard",
        layout: "/admin",
        path: "finished-products/dashboard",
        icon: <MdHome className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <FinishedDashboard />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Lanes",
        layout: "/admin",
        path: "finished-products/zones",
        icon: <MdWarehouse className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <FinishZone />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Product List",
        layout: "/admin",
        path: "finished-products/list",
        icon: <MdList className="h-6 w-6" />,
        component: <ProtectedRoute><ProductList /></ProtectedRoute>,
        selectable: true
      },
      {
        name: "Add Product",
        layout: "/admin",
        path: "finished-products/add",
        icon: <MdAdd className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddFinProduct />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Age Analysis/Rework",
        layout: "/admin",
        path: "finished-products/age",
        icon: <MdTimer className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Age />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Product Details",
        layout: "/admin",
        path: "finished-product-warehouse/product-details",
        component: (
          <ProtectedRoute>
            <ProductDetails />
          </ProtectedRoute>
        ),
        hidden: true,
        selectable: false,
      },
      {
        name: "Product Type Details",
        layout: "/admin",
        path: "finished-product-warehouse/:productType",
        component: (
          <ProtectedRoute>
            <ProductTypeDetail />
          </ProtectedRoute>
        ),
        hidden: true,
        selectable: false,
      },
      {
        name: "Zone Details",
        layout: "/admin",
        path: "finished-products/zones/:zoneId",
        component: <FinishZoneDetails />,
        hidden: true,
        selectable: false,
      },
      {
        name: "Export Products",
        layout: "/admin",
        path: "finished-products/export",
        icon: <MdOutlineShoppingCart className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Export />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Rework Records",
        layout: "/admin",
        path: "finished-products/rework-records",
        icon: <MdBuild className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ReworkRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Deleted Product Records",
        layout: "/admin",
        path: "finished-products/deleted-records",
        icon: <MdDelete className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <DeletedProductRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Export Records",
        layout: "/admin",
        path: "finished-products/export-records",
        icon: <MdLocalShipping className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ExportRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Reports",
        layout: "/admin",
        path: "finished-products/reports",
        icon: <MdAssessment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Report />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      
      {
        name: "Daily Report",
        layout: "/admin",
        path: "finished-products/reports/daily",
        component: (
          <ProtectedRoute>
            <DailyReport />
          </ProtectedRoute>
        ),
        hidden: true,
      },
      {
        name: "Sales Forecast Report",
        layout: "/admin",
        path: "finished-products/reports/sales-forecast",
        component: (
          <ProtectedRoute>
            <SalesForecastReport />
          </ProtectedRoute>
        ),
        hidden: true,
      },
    ]
  },
  {
    name: "Quality Analysis",
    layout: "/admin",
    path: "analyst-process",
    icon: <MdAnalytics className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <AnalystDashboard />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('analystProcess'),
    submenu: [
      {
        name: "Dashboard",
        layout: "/admin",
        path: "analyst-process/dashboard",
        icon: <MdHome className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AnalystDashboard />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit(),
      },
      // {
      //   name: "Product Distribution",
      //   layout: "/admin",
      //   path: "analyst-process/product-distribution",
      //   icon: <MdBarChart className="h-5 w-5" />,
      //   component: (
      //     <ProtectedRoute>
      //       <ProductDistribution />
      //     </ProtectedRoute>
      //   ),
      //   selectable: true,
      //   hidden: () => isFieldAnalysisUnit(),
      // },
      {
        name: "Product Analysis",
        layout: "/admin",
        path: "analyst-process/product-analysis",
        icon: <MdCategory className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AnalysesEntryCard />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit(),
        submenu: [
          {
            name: "Analysis Entry",
            layout: "/admin",
            path: "analyst-process/entry-card",
            icon: <MdEditNote className="h-5 w-5" />,
            component: (
              <ProtectedRoute>
                <AnalysesEntryCard />
              </ProtectedRoute>
            ),
            selectable: true,
            hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit(),
          },
          {
            name: "Product Analysis Entry (Pieces)",
            layout: "/admin",
            path: "analyst-process/entry1",
            icon: <MdCheckCircle className="h-5 w-5" />,
            component: (
              <ProtectedRoute>
                <AnalystEntry1 />
              </ProtectedRoute>
            ),
            selectable: true,
            hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit() || isAnalystUser(),
          },
          {
            name: "Product Analysis Entry (Wholes)",
            layout: "/admin",
            path: "analyst-process/entry2",
            icon: <MdDescription className="h-5 w-5" />,
            component: (
              <ProtectedRoute>
                <AnalystEntry2 />
              </ProtectedRoute>
            ),
            selectable: true,
            hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit() || isAnalystUser(),
          },
          {
            name: "Wholes Records",
            layout: "/admin",
            path: "analyst-process/wholes-records",
            icon: <MdStorage className="h-5 w-5" />,
            component: (
              <ProtectedRoute>
                <WholesRecords />
              </ProtectedRoute>
            ),
            selectable: true,
            hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit(),
          },
          {
            name: "Pieces Records",
            layout: "/admin",
            path: "analyst-process/pieces-records",
            icon: <MdList className="h-5 w-5" />,
            component: (
              <ProtectedRoute>
                <PiecesRecords />
              </ProtectedRoute>
            ),
            selectable: true,
            hidden: () => isFieldAnalysisUnit() || isFactoryAnalystUnit(),
          },
        ],
      },
      {
        name: "RCN Analysis",
        layout: "/admin",
        path: "analyst-process/rcn-analysis",
        icon: <MdAgriculture className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <FieldAnalysis />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: false,
        submenu: [
          {
            name: "Factory Analysis",
            icon: <MdFactory className="h-5 w-5" />,
            selectable: true,
            hidden: () => !isFactoryAnalystUnit() && !isAnalystUser() && !accessControl.isAdmin(),
            submenu: [
              {
                name: "Add Raw RCN",
                layout: "/admin",
                path: "analyst-process/add-raw-rcn",
                icon: <MdAddCircle className="h-5 w-5" />,
                component: (
                  <ProtectedRoute>
                    <AddRawRCN />
                  </ProtectedRoute>
                ),
                selectable: true,
                hidden: () => !isFactoryAnalystUnit() && !isAnalystUser() && !accessControl.isAdmin(),
              },
              {
                name: "Receiving Records",
                layout: "/admin",
                path: "analyst-process/receiving-records",
                icon: <MdInventory className="h-5 w-5" />,
                component: (
                  <ProtectedRoute>
                    <ReceivingRecords />
                  </ProtectedRoute>
                ),
                selectable: true,
                hidden: () => !isFactoryAnalystUnit() && !isAnalystUser() && !accessControl.isAdmin(),
              },
            ],
          },
          {
            name: "Field Analysis",
            icon: <MdScience className="h-5 w-5" />,
            selectable: true,
            hidden: () => {
              const hideFieldAnalysis = isAnalystUser() || isFactoryAnalystUnit();
              const hideFieldRecords = isFactoryAnalystUnit();
              return hideFieldAnalysis && hideFieldRecords;
            },
            submenu: [
              {
                name: "Field Analysis",
                layout: "/admin",
                path: "analyst-process/field-analysis",
                icon: <MdScience className="h-5 w-5" />,
                component: (
                  <ProtectedRoute>
                    <FieldAnalysis />
                  </ProtectedRoute>
                ),
                selectable: true,
                hidden: () => isAnalystUser() || isFactoryAnalystUnit(),
              },
              {
                name: "Field Analysis Records",
                layout: "/admin",
                path: "analyst-process/field-analysis-records",
                icon: <MdBarChart className="h-5 w-5" />,
                component: (
                  <ProtectedRoute>
                    <FieldAnalysisRecords />
                  </ProtectedRoute>
                ),
                selectable: true,
                hidden: () => isFactoryAnalystUnit(),
              },
            ],
          },
        ],
      }
    ]
  },
  {
    name: "Cashew Price",
    layout: "/admin",
    path: "cashew-price",
    icon: <MdAssessment className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <PriceInput />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('cashewPrice'),

    submenu: [
      {
        name: "Price Management",
        layout: "/admin",
        path: "cashew-price",
        icon: <MdAssessment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <PriceInput />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Pickup Requests",
        layout: "/admin",
        path: "cashew-price/requests",
        icon: <MdAssignment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Request />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Agent Requests",
        layout: "/admin",
        path: "cashew-price/agent-requests",
        icon: <MdAssignment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AgentRequest />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      // {
      //   name: "Visit Requests",
      //   layout: "/admin",
      //   path: "cashew-price/visit-requests",
      //   icon: <MdAssignment className="h-5 w-5" />,
      //   component: (
      //     <ProtectedRoute>
      //       <VisitRequest />
      //     </ProtectedRoute>
      //   ),
      //   selectable: true,
      // },
      {
        name: "Farmers List",
        layout: "/admin",
        path: "cashew-price/farmers",
        icon: <MdPerson className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <FarmerList />
          </ProtectedRoute>
        ),
        selectable: true,
      }
    ]
  },
  {
    name: "Manual Peeling",
    layout: "/admin",
    path: "manualpeeling",
    icon: <MdBuild className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <AddManPeelingData />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('manualPeeling'),

    submenu: [
      {
        name: "Add Data",
        layout: "/admin",
        path: "manualpeeling/add",
        icon: <MdAdd className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddManPeelingData />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Performance",
        layout: "/admin",
        path: "manualpeeling/performance",
        icon: <MdAssessment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <Performance />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Add Worker",
        layout: "/admin",
        path: "manualpeeling/add-worker",
        icon: <MdPerson className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AddWorker />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Worker List",
        layout: "/admin",
        path: "manualpeeling/worker-list",
        icon: <MdGroup className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <WorkerList />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Data Records",
        layout: "/admin",
        path: "manualpeeling/data-records",
        icon: <MdReceipt className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <DataRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "SMS Notification",
        layout: "/admin",
        path: "manualpeeling/sms-notification",
        icon: <MdNotificationsActive className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <SMSNotification />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Absent Check",
        layout: "/admin",
        path: "manualpeeling/absent-check",
        icon: <MdWorkOff className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <AbsentCheck />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Risk Report",
        layout: "/admin",
        path: "manualpeeling/risk-report",
        icon: <MdWarning className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <RiskReport />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      // {
      //   name: "Comparison",
      //   layout: "/admin",
      //   path: "manualpeeling/comparison",
      //   icon: <MdCompare className="h-5 w-5" />,
      //   component: (
      //     <ProtectedRoute>
      //       <Comparison />
      //     </ProtectedRoute>
      //   ),
      //   selectable: true,
      // },
      {
        name: "Worker Profile",
        layout: "/admin",
        path: "manualpeeling/worker/:id",
        icon: <MdPerson className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <WorkerProfile />
          </ProtectedRoute>
        ),
        selectable: false,
        hidden: true,
      }
    ]
  },
  // {
  //   name: "Training & Learning",
  //   layout: "/admin",
  //   path: "lms",
  //   icon: <MdSchool className="h-6 w-6" />,
  //   component: (
  //     <ProtectedRoute>
  //       <LMSLearning />
  //     </ProtectedRoute>
  //   ),
  //   selectable: true,
  //   submenu: [
  //     {
  //       name: "Domain Performance",
  //       layout: "/admin",
  //       path: "lms/domain-performance",
  //       icon: <MdRadar className="h-5 w-5" />,
  //       component: (
  //         <ProtectedRoute>
  //           <DomainPerformanceDashboard />
  //         </ProtectedRoute>
  //       ),
  //       selectable: true,
  //     },
  //     {
  //       name: "Learning Content",
  //       layout: "/admin",
  //       path: "lms/learning",
  //       icon: <MdMenuBook className="h-5 w-5" />,
  //       component: (
  //         <ProtectedRoute>
  //           <LMSLearning />
  //         </ProtectedRoute>
  //       ),
  //       selectable: true,
  //     },
  //   ],
  // },
  {
    name: "RCN Delivery",
    layout: "/admin",
    path: "rcn-delivery",
    icon: <MdLocalShipping className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <RcnDeliveryDashboard />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: shouldHideMenu('rcnDelivery'),
    submenu: [
      {
        name: "Dashboard",
        layout: "/admin",
        path: "rcn-delivery/dashboard",
        icon: <MdHome className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <RcnDeliveryDashboard />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Delivery Form",
        layout: "/admin",
        path: "rcn-delivery/form",
        icon: <MdAssignment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <DeliveryForm />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Dispatch Records",
        layout: "/admin",
        path: "rcn-delivery/records",
        icon: <MdReceipt className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <DispatchRecords />
          </ProtectedRoute>
        ),
        selectable: true,
      },
      {
        name: "Incidence Report",
        layout: "/admin",
        path: "rcn-delivery/incidence-report",
        icon: <MdWarning className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <IncidenceReport />
          </ProtectedRoute>
        ),
        selectable: false,
        hidden: true,
      },
    ]
  },
  {
    name: "Shift",
    layout: "/admin",
    path: "shift",
    icon: <MdNotificationsActive className="h-6 w-6" />,
    component: (
      <ProtectedRoute>
        <ShiftSMS />
      </ProtectedRoute>
    ),
    selectable: true,
    hidden: () => !accessControl.isAdmin(),
    submenu: [
      {
        name: "SMS",
        layout: "/admin",
        path: "shift/sms",
        icon: <MdNotificationsActive className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ShiftSMS />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: false,
      },
      {
        name: "Report",
        layout: "/admin",
        path: "shift/report",
        icon: <MdAssessment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <WorkerHoursReport />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: false,
      },
      {
        name: "Shift Logs",
        layout: "/admin",
        path: "shift/logs",
        icon: <MdSearch className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ShiftLogs />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: false,
      },
      {
        name: "Nurse Leave",
        layout: "/admin",
        path: "shift/nurse-leave",
        icon: <MdLocalHospital className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <NurseLeave />
          </ProtectedRoute>
        ),
        selectable: false,
        hidden: true,
      },
      {
        name: "HR Manager",
        layout: "/admin",
        path: "shift/hr-manager",
        icon: <MdDirectionsRun className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <HRManager />
          </ProtectedRoute>
        ),
        selectable: false,
        hidden: true,
      },
      {
        name: "Passes",
        layout: "/admin",
        path: "shift/pass-create",
        icon: <MdDirectionsRun className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <PassCreate />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: false,
      },
      {
        name: "Records",
        layout: "/admin",
        path: "shift/records",
        icon: <MdAssignment className="h-5 w-5" />,
        component: (
          <ProtectedRoute>
            <ShiftRecords />
          </ProtectedRoute>
        ),
        selectable: true,
        hidden: true,
      },
    ],
  },
];
export default routes;